import AutoplayVideo from './AutoplayVideo';

export default class AutoplayVideos {
	constructor() {
		this.autoplayVideos = [];

		document.addEventListener('unbless', () => {
			this.autoplayVideos.forEach((autoplayVideo) => {
				autoplayVideo.destroy();
			});

			this.autoplayVideos = [];
		});
	}

	init(element) {
		const videos = element.querySelectorAll('[data-autoplay-video]');

		this.autoplayVideos = Array.from(videos).map((video) => {
			return new AutoplayVideo(video);
		});
	}
}
